import React from 'react';
import { Form, FormGroup, Label, Input } from 'reactstrap';

export const validateUserForm = (userForm, isEdit) => {
    let errors = '';

    if (!userForm.email) {
        errors += "  Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(userForm.email)) {
         errors += "  Invalid email format.";
    }

    if (!userForm.firstName.trim()) {
         errors += "  First name is required.";
    }

    if (!userForm.lastName.trim()) {
         errors += "  Last name is required.";
    }

    if (!userForm.company) {
        errors += "  Company is required.";
    }

    if (!isEdit && !userForm.password) {
        errors += "  A password is required.";
    }

    if (userForm.confirmPassword !== userForm.password) {
         errors += "  Passwords do not match.";
    }

    return errors.trim();
};

const UserForm = ({ userForm, onChange, showManagementFields }) => {
    return (
        <Form>
            <FormGroup>
                <Label for="email">Email</Label>
                <Input
                    type="email"
                    name="email"
                    id="email"
                    value={userForm.email}
                    onChange={onChange}
                />
            </FormGroup>
            <FormGroup>
                <Label for="firstName">First Name</Label>
                <Input
                    type="text"
                    name="firstName"
                    id="firstName"
                    value={userForm.firstName}
                    onChange={onChange}
                />
            </FormGroup>
            <FormGroup>
                <Label for="lastName">Last Name</Label>
                <Input
                    type="text"
                    name="lastName"
                    id="lastName"
                    value={userForm.lastName}
                    onChange={onChange}
                />
            </FormGroup>
            <FormGroup>
                <Label for="company">Company</Label>
                <Input
                    type="text"
                    name="company"
                    id="company"
                    value={userForm.company}
                    onChange={onChange}
                />
            </FormGroup>
            <FormGroup>
                <Label for="phone">Phone</Label>
                <Input
                    type="text"
                    name="phone"
                    id="phone"
                    value={userForm.phone}
                    onChange={onChange}
                />
            </FormGroup>
            {showManagementFields &&
                <>
                    <FormGroup>
                        <Label for="role">Role</Label>
                        <Input
                            type="select"
                            name="role"
                            id="role"
                            value={userForm.role}
                            onChange={onChange}
                        >
                            <option value="USER">USER</option>
                            <option value="ADMIN">ADMIN</option>
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="status">Status</Label>
                        <Input
                            type="select"
                            name="status"
                            id="status"
                            value={userForm.status}
                            onChange={onChange}
                        >
                            <option value="ACTIVE">ACTIVE</option>
                            <option value="DISABLED">DISABLED</option>
                        </Input>
                    </FormGroup>
                </>
            }
            <FormGroup>
                <Label for="password">Password</Label>
                <Input
                    type="password"
                    name="password"
                    id="password"
                    value={userForm.password}
                    onChange={onChange}
                />
            </FormGroup>
            <FormGroup>
                <Label for="confirmPassword">Confirm Password</Label>
                <Input
                    type="password"
                    name="confirmPassword"
                    id="confirmPassword"
                    value={userForm.confirmPassword}
                    onChange={onChange}
                />
            </FormGroup>
        </Form>
    );
};

export default UserForm;
